export default __webpack_public_path__ + "static/media/ficha-treino-mobile-aluno.b7646205.png";